// extracted by mini-css-extract-plugin
export default {"downloadButton":"download_downloadButton__Cg5nI","chevron":"download_chevron__TS-ND","spinIcon":"download_spinIcon__jOB5E","spin":"download_spin__kyqnS"};